<template>
  <div v-if="active" class="modal is-active is-unselectable">
    <div class="modal-background"></div>
    <aside class="modal-card is-flex">
      <button v-if="!this.isEngArticle" qa="postResourceModalCloseButton" aria-label="To close modal" class="close gtm-login-close cursor-pointer" @click="close(false)"><i class="fal fa-times"></i></button>
      <header v-if="shouldShowQuestionModal">
        <h2 class="title welcome-modal">{{ $t(questionModalTitle) }}</h2>
      </header>
      <form class="form" v-if="shouldShowQuestionModal">
        <div class="questions-section">
          <generic-input
                  v-if="isNeedFullname" v-model="firstName"
                  placeholder="First name" :inputName="firstName" :width="'100%'"
                  :error="isFirstnameError ? 'Please provide your first name.' : ''">
          </generic-input>
          <generic-input
                  v-if="isNeedFullname" v-model="lastName"
                  placeholder="Last name" :inputName="lastName" :width="'100%'"
                  :error="isLastnameError ? 'Please provide your last name.' : ''">
          </generic-input>
          <generic-input
                  v-if="isNeedEmail" v-model="email"
                  placeholder="Email" :inputName="email" :width="'100%'"
                  :error="isEmailError ? 'Please provide a valid Email.' : ''">
          </generic-input>
          <div v-for="(question, index) in questions" :key="question.title">
              <generic-input
                      v-if="question.type === 'text'"
                      v-model="answers[index].answer" :ref="question"
                      :placeholder="question.label" :inputName="question.label" :width="'100%'">
              </generic-input>
              <dropdown
                      v-if="question.type === 'list'"
                      v-model="answers[index].optionIDs[0]" :items="question.answers"
                      :inputName="question.question" :placeholder="question.label"
                      width="350px" :isUp="index > (questions.length / 2)" :isWebinarSignupModal="shouldShowQuestionModal">
              </dropdown>
            <div v-if="errors[index]" id="error-container" class="help has-text-danger error error-form">{{errors[index]}}</div>
          </div>
        </div>
        <div class="next-button-container">
          <checkbox :label="getGdprMsg()" v-model="gdprChecked" class="gdpr-checkbox is-size-7 has-text-grey"/>
          <div v-if="error" class="has-text-danger help title-error">{{ error }}</div>
          <button v-if="!loadingQuestions" qa="next-btn" class="button is-primary is-full-width submit-button" @click.prevent="validateAndSubmitAnswers" :disabled="loading || !gdprChecked"><span v-if="loading" class="loader add-margin"></span>{{ $t("resource.next")}}</button>
          <span v-if="loadingQuestions" class="loader"></span>
        </div>
      </form>
      <section v-if="shouldShowDownloadModal && !loadingQuestions" class="confirm-section">
        <div class="subtitle welcome-modal">{{ questionModalTitle }}</div>
        <div class="next-button-container">
          <!-- ToDo AddToCalendar Functionality. Uncomment line below for button -->
          <!-- <div v-if="resourceType === 'webinar'" class="button is-primary is-full-width continue-button" @click="addToCalendar">{{ $t("resource.addToCalendar")}}</div> -->
          <p class="confirmation-text" v-if="isWebinar">
            <span v-html="webinarConfirmMessage"></span>
            <!-- {{ $t("resource.viewWebinar")}} WE DON'T HAVE A VIEW WEBINARS PAGE YET -->
          </p>
          <div class="register-container">
            <checkbox v-if="!showedQuestionModal" :label="getGdprMsg()" v-model="gdprChecked" class="gdpr-checkbox gdpr-modal-2 is-size-7 has-text-grey"/>
            <button v-if="(!isWebinar || !showedQuestionModal) && !isEngArticle" class="button is-primary is-full-width continue-button" qa="next-btn" @click="openDownloadLink()" :disabled="!gdprChecked">{{ modalButtonText }}</button>
            <button v-if="((!isWebinar || !showedQuestionModal) && isEngArticle)" class="button is-primary is-full-width continue-button" @click="validateAndSubmitAnswers" :disabled="!gdprChecked">{{ modalButtonText }}</button>
          </div>
        </div>
        <div v-if="!this.isEngArticle" class="recommendations-container">
          <p class="has-text-weigth-semibold">YOU MAY ALSO WANT...</p>
          <div class="recommendations">
            <a v-for="(resource, index) in recommendations" :key="index" target="_blank" class="resource-container" :href="`${resource._source.link}`">
              <img :src="getCloudinary(resource._source.imageurl)" alt="">
              <div class="title-container">
                <h3>{{resource._source.resourcename}}</h3>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section v-if="shouldShowDownloadModal && loadingQuestions" class="confirm-section">
        <div class="only-loader">
            <span class="loader"></span>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
import Checkbox from '@/components/Controls/Checkbox'
import GenericInput from '@/components/Controls/GenericComponents/input'
import Dropdown from '@/components/Controls/GenericComponents/dropdown'

import users from '@/api/users'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import gaTrackingMixin from '@/mixins/ga-tracking'
import resources from '@/mixins/resources'

import i18n from '@/i18n'

export default {
  props: ['project'],
  components: {
    Checkbox,
    GenericInput,
    Dropdown
  },
  mixins: [resources, componentState, auth, gaTrackingMixin],
  data: function () {
    return {
      active: false,
      showError: false,
      counter: 0,
      recommendations: [],
      isScrollLocked: false,
      gdprChecked: false,
      firstName: '',
      lastName: '',
      email: '',
      isFirstnameError: false,
      isLastnameError: false,
      showedQuestionModal: false,
      isNeedEmail: false,
      isEmailError: false
    }
  },
  computed: {
    user: function () {
      return this.$store.getters.currentUser
    },
    doneButtonText: function () {
      if (this.isCreate) {
        return this.$t('next')
      }
      if (!this.isLoggedIn) {
        return this.$t('modalCategories.customizeFeed')
      }
      if (this.signingUp) {
        return this.$t('done')
      }
      if (!this.signingUp) {
        return this.$t('finish')
      }
    },
    loadingMessage: function () {
      return this.hasLoadingError ? 'Looks like something went wrong. Please close and try again' : 'Loading your categories...'
    },
    userNotFoundError: function () {
      return this.error === 'User not found'
    },
    resourceType: function () {
      return this.project.resource.type.name
    },
    webinarID: function () {
      return this.project.resource && this.project.resource.webinar ? this.project.resource.webinar.go_to_webinar_id : ''
    },
    webinarConfirmMessage: function () {
      let message = ''
      if (this.showedQuestionModal) {
        message = i18n.t('resource.nowRegistered')
      } else {
        message = i18n.t('resource.youAreRegistering')
      }
      message += '<br><b>' + this.project.title + '</b></br>' + i18n.t('resource.on') + '<br><b>' + this.webinarDate + '</b></br>'
      if (!this.isPastWebinar) {
        message += i18n.t('resource.checkEmail')
      }
      return message
    },
    isNeedFullname: function () {
      return this.user.fullName === '' || this.user.fullName === null
    },
    isNeedAnswers: function () {
      return this.questions.length > 0 || this.isNeedFullname
    },
    isEngArticle: function () {
      return this.articleID > 0
    },
    isGated: function () {
      return this.project.isGated
    },
    shouldShowGatedTermsModal () {
      return this.project.show_gated_terms_modal
    },
    articleID: function () {
      return this.project?.article?.id || 0
    },
    fullName: function () {
      if (this.isNeedFullname) {
        return this.firstName.trim() + ' ' + this.lastName.trim()
      } else {
        return ''
      }
    },
    modalButtonText: function () {
      if (this.isWebinar) {
        return i18n.t('resource.watchWebinar')
      } else if (this.isEngArticle) {
        return i18n.t('article.continue')
      } else {
        return i18n.t('resource.download')
      }
    },
    questionModalTitle: function () {
      if (this.isEngArticle) {
        return this.isNeedAnswers ? i18n.t('article.signUp') : i18n.t('resource.allSet')
      } else {
        return i18n.t('resource.signUp')
      }
    },
    shouldShowQuestionModal: function () {
      return this.counter === 0 && (this.isNeedAnswers || (this.isWebinar && !this.isPastWebinar))
    },
    shouldShowDownloadModal: function () {
      return this.counter === 1 || (this.counter === 0 && !this.isNeedAnswers && (this.isPastWebinar || !this.isWebinar))
    }
  },
  watch: {
    questions: function (questions) {
      if (questions.length === 0 && this.isNeedFullname) {
        this.$store.dispatch('isRegistered', true)
      }
    }
  },
  mounted: function () {
  },
  destroyed: function () {
    this.toggleScrollLock('unlockScrolling')
  },
  methods: {
    showModal: function () {
      this.fetchQuestions()
      this.active = true
      this.toggleScrollLock('lockScrolling')
      this.checkResourceQuestions()
      // Should only Check if Article isGated
      if (!this.shouldShowGatedTermsModal && this.isGated) {
        this.done()
      }
      if (this.recommendations.length === 0) {
        this.fetchResourceRecommendations()
      }
    },

    fetchResourceRecommendations: async function () {
      try {
        await fetch(`https://sm5whnocrb.execute-api.us-east-1.amazonaws.com/resources?size=3&title=title=${this.project.title}&type=${this.project.resource.type.id}`)
          .then(response => response.json())
          .then(data => data.hits.hits.forEach(item => {
            this.recommendations.push(item)
          }))
        return this.recommendations
      } catch (error) {
        console.error(error)
      }
    },
    getCloudinary: function (resourceurl) {
      return 'http://res.cloudinary.com/engineering-com/image/fetch/w_100,h_65,f_jpg,c_fill/' + resourceurl
    },
    toggleScrollLock: function (key) {
      this.isScrollLocked = !this.isScrollLocked
      this._callback(key, !this.isScrollLocked)
    },
    fetchQuestions: async function () {
      if (!this.isLoggedIn || this.loadingQuestions) {
        return
      }
      this.loadingQuestions = true
      if (this.questions.length === 0) {
        if (this.isEngArticle) {
          await this.$store.dispatch('getUnansweredQuestionsForUserOrProject', {
            userID: this.$store.getters.currentUser.id,
            projectID: parseInt(this.project.id)
          }).then((response) => {
            this.questions = response.questions
            if (response.questions.length > 0 && response.questions[0].question === 'email') {
              this.questions.shift()
              this.isNeedEmail = true
            }
            this.answers = []
            this.questions.forEach((question) => {
              const newAnswer = JSON.parse(JSON.stringify(this.userAnswer))
              newAnswer.questionID = question.id
              this.answers.push(newAnswer)
            })
          })
        } else {
          await this.$store.dispatch('getQuestionsForUserOrResource', {
            userID: this.$store.getters.currentUser.id,
            resourceID: parseInt(this.project.resource.id)
          }).then((response) => {
            this.questions = response.questions
            if (response.questions.length > 0 && response.questions[0].question === 'email') {
              this.questions.shift()
              this.isNeedEmail = true
            }
            this.answers = []
            this.questions.forEach((question) => {
              const newAnswer = JSON.parse(JSON.stringify(this.userAnswer))
              newAnswer.questionID = question.id
              this.answers.push(newAnswer)
            })
          })
        }
      }
      this.loadingQuestions = false
    },
    done: function () {
      this.close(true)
    },
    close: function (resetVars) {
      this.active = false
      if (resetVars) {
        this.resetVars()
      }
      this.$emit('modalDone', true, true)
      this.$store.dispatch('resourceButtonClicked', false)
      this.toggleScrollLock('unlockScrolling')
      if (this.counter !== 1) {
        this.counter = 0
      }
    },
    getGdprMsg: function () {
      return this.isEngArticle ? i18n.t('article.gdprMsg') : this.project.resource.gdprMsg
    },
    resetVars: function () {
      this.errors = []
      this.error = ''
      this.showError = false
      this.answers = []
      this.counter = 0
      this.loading = false
      this.questions = []
      this.gdprChecked = false
      this.firstName = ''
      this.lastName = ''
      this.isFirstnameError = false
      this.isLastnameError = false
      this.isEmailError = false
    },
    validateAndSubmitAnswers: function () {
      this.showedQuestionModal = true
      let isValid = true
      if (this.isNeedFullname) {
        this.isFirstnameError = this.firstName.trim().length < 2
        this.isLastnameError = this.lastName.trim().length < 2
        if (this.isFirstnameError || this.isLastnameError || this.isEmailError) {
          return
        }
      }

      if (!this.validEmail(this.email) && this.isNeedEmail) {
        this.isEmailError = true
        return this.isEmailError
      }
      isValid = this.validateQuestions(true)
      if (isValid) {
        if (this.isEngArticle) {
          this.submitAnswers(false)
          this.done()
        } else {
          this.submitAnswers(true)
        }
      }
      if (this.isGated) {
        this.trackGatedProjectUserDownload()
      }
    },
    validEmail: function (email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(String(email).toLowerCase())
    },
    openDownloadLink: function () {
      if (!this.showedQuestionModal) {
        if (this.isUpcoming) {
          this.registerForWebinar()
        } else {
          this.done()
          this.trackUserResourceDownload()
        }
      }
      // always track download info - inc. webinars
      this.trackResourceDownloadForGA()
      if (this.isWebinar) {
        this.close(true)
      } else {
        window.open(this.project.resource.resource_link, '_blank')
      }
    },
    trackResourceDownloadForGA: function () {
      this.trackResourceDownloadGA(this.project.resourceID)
    },
    checkResourceQuestions: function () {
      this.fetchQuestions()
    },
    registerForWebinar: async function () {
      try {
        const response = await users.registerForWebinar(this.webinarID)
        if (response.data.status !== 'ok') {
          throw new Error()
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $modal-body-color: #F2F2F2;
  $modal-footer-color: #F7F7F7;
  $close-icon-color: #1A051D;
  $border-color: #DCDCDC;
  $bottom-message-font-color: #3F3F3F;

  .modal {
    z-index: 15;
    height:auto;
    width:auto;
  }

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    height:auto;
    width:575px;
    min-width: 375px;
    max-height: 1000px;
    max-width: 575px;
    display: flex;
    align-items: center;
    @include mobile {
      width: 100% !important;
      max-height: 80%;
      top: 5%;
    }

    // HEADER
    .title {
      border-bottom: 1px solid $border-color;
      padding: 1.3rem 0;
      // margin-top: -150px;
      font-family: 'Noto Serif JP, Serif';
      font-weight: normal;
      h2 {
        font-family: $primary-font;
        font-weight: $primary-font-weight;
        font-size: 1.5rem;
      }
    }
  }

  .subtitle {
    border-bottom: 1px solid $border-color;
    padding: 1.3rem 0;
    margin-top: 0px;
    font-family: 'Noto Serif JP, Serif';
    font-weight: normal;
    font-size: 1.9rem;
    h2 {
      font-family: $primary-font;
      font-weight: $primary-font-weight;
      font-size: 1.9rem;
    }
  }

  .close {
    top: 0.4rem;
    right: 1rem;
    position: absolute;
    font-size: 1.5rem;
    color:  $close-icon-color;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: $link-hover;
    }
  }

  .section {
    height: auto;
    padding: 0;

    .container {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    width: 400px;
  }
  }

  .terms-of-service {
    font-family: 'Roboto';
    font-weight: 300;
    font-size: 0.9rem;
    padding: 0.3rem 0 0.5rem;
    a {
      color: #373737;
      text-decoration: underline;
      &:hover {
        color: $link-hover;
      }
      @include mobile {
        display: block;
      }
    }
  }

  .confirmation-text {
    padding-bottom: 10px;
    max-width: 425px;
  }

  .title-error {
    margin-bottom: 1rem;
  }

  .form {
    margin: auto;
    padding-top: 0rem;
    align-items: center;
    text-align: left;
    .control {
      flex-direction: column;
      max-width: 650px;

    }
    .radio {
      margin-left: 0;
      padding-bottom: 0.5rem;
    }
    .saveButton {
      margin-top: 1rem;
    }
  }
  .radio-button {
    min-width: 1rem;
    min-height: 1rem;
    width: 1rem;
    height: 1rem;
    color:green;
  }

  .option-title {
    font-family: 'Noto Serif JP, Serif';
    font-weight: bold;
    margin: auto;
    padding-top: 10px;
    text-transform: capitalize;
  }

  .radio-option {
    font-family: 'Noto Serif JP, Serif';
    font-weight: normal;
    margin: auto;
    padding-top: 8px;
    text-transform: capitalize;
  }

  .questions-section {
    margin-top: 10px;
    margin-left: 1.3%;
    margin-right: 1%;
    width: 97%;
  }
  .next-button-container {
    padding-bottom: 10px;
    margin-bottom: 2.5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .only-loader {
    margin: auto;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7rem 0;
    font-size: 1.9rem;
  }

  .radio-container {
    margin: auto;
    width: 64%;
  }
  .recommendations-container {
    p {
      font-family: sans-serif;
      color: $primary;
      font-weight: 600;
      font-size: 0.75rem;
      text-align: left;
    }
    margin: 0 4rem;
    margin-top: 1.5rem;
    margin-bottom: 4rem;
    font-family: 'Noto Serif JP, Serif';
  }

  .recommendations-container:hover {
    cursor: pointer;
  }

  .submit-button {
    border-radius: 0;
    text-transform: uppercase;
    font-weight: 600;
    padding: 0.7rem 1.2rem;
    font-size: 0.9rem;
    letter-spacing: 1px;
    margin-bottom: 1rem;
    .add-margin {
      margin-right: 0.5rem;
    }
  }

  .recommendations {
    display: flex;
    flex-direction: column;
    img {
      height: 65px;
      width: 100px;
      display: inline-block;
    }
  }

  .resource-container {
    display: flex;
    margin: 0.35rem 0;
    .title-container {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: left;
      h3 {
        font-size: 0.95rem;
        line-height: 1.1rem;
        color: black;
        max-width: 322px;
        padding-left: 1rem;
      }
    }
  }

  .confirm-section {
    @include mobile {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  .next-button-container p.confirmation-text {
    @include mobile {
      width: 263px;
      text-align: center;
    }
  }

  .gdpr-checkbox {
    padding-bottom: 10px;
  }

  .gdpr-modal-2 {
    width: 450px;
    @include mobile {
      width: 300px;
    }
  }

  .continue-button {
    width: 120px;
  }

  .register-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .checkboxes {
    width: 430px;
    @include mobile {
      width: 350px;
    }
  }

  .error-form {
    position: relative;
    bottom: 10px;
  }
  confirm-visibility .modal-background {
    display: none !important;
  }
  .confirm-visibility aside.modal-card {
    display: block !important;
    position: fixed;
    top: auto;
    bottom: 15%;
    margin: auto;
    display: flex !important;
    max-height: min-content;
    -webkit-box-shadow: 0px 0px 20px -1px rgb(0 0 0 / 20%);
    box-shadow: 0px 0px 20px -1px rgb(0 0 0 / 20%);
    background: #fff;
    border-radius: 5px;
    form {
      .next-button-container {
        margin-bottom: 15px;
      }
    }
  }
  .modal.is-active.confirm-visibility {
    display: flex !important;
    max-width: 575px;
    margin-left: auto;
    margin-right: auto;
    height: 0px;
  }
</style>
